module.exports = __webpack_public_path__ + "media/components/app-store/static/s1-f3926e73fa342aa07352629c0a48877c.png";